import { Injectable, NgModule, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
//import { MomentModule } from 'angular2-moment';
//import { MomentTimezoneModule } from 'angular-moment-timezone';
//import * as moment from 'moment';
//import 'moment/locale/pt-br';
//import moment from 'moment-timezone';

@Injectable()

@NgModule({
  imports: [MatDialogModule, BrowserAnimationsModule, FormsModule]
})

export class CommonService {
  myAppUrl: string = "";

  constructor(private _http: Http, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  //** Common
  getDateTime(TDate: Date) {
    return (TDate.getMonth() + 1).toString() + "/" + TDate.getDate().toString() + "/" +
      TDate.getFullYear().toString() + " " + TDate.getHours().toString() + ":" +
      TDate.getMinutes().toString() + ":" + TDate.getSeconds().toString();
  }

  //第二弾
  changeDateTime(TDate: Date) {
    let rDate = new Date(TDate.getFullYear(), TDate.getMonth(), TDate.getDate());
    return new Date(rDate.setMonth(rDate.getMonth() + 1));
  }

  //第三弾
  ////** Date Time
  //getDateTime(TDate: Date) {
  //  let NowLocal = moment(moment.utc(TDate)).local();
  //  return NowLocal;
  //}

  //changeDateTimeJ(TDate: Date) {
  //  //let NowLocal = moment(moment.utc(TDate)).local('ja');
  //  let NowLocal = moment(moment.utc(TDate)).local();
  //  return NowLocal;
  //}
  //changeDateTimeE(TDate: Date) {
  //  let NowLocal = moment(moment.utc(TDate)).local();
  //  return NowLocal;
  //}

  //第4弾
  ////** Date Time
  //getDateTime(TDate: Date) {
  //  return moment();
  //}

  //changeDateTimeJ(TDate: Date) {
  //  //let NowLocal = moment(moment.utc(TDate)).local('ja');
  //  return moment();
  //}

  //changeDateTimeE(TDate: Date) {
  //  return moment();
  //}

  getMonthDropDownList() {
    return [
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12
    ];
  }

  getYearDropDownList() {
    return [
      2000,
      2001,
      2002,
      2003,
      2004,
      2005,
      2006,
      2007,
      2008,
      2009,
      2010,
      2011,
      2012,
      2013,
      2014,
      2015,
      2016,
      2017,
      2018,
      2019,
      2020,
      2021,
      2020,
      2021,
      2022,
      2023,
      2024,
      2025,
      2026,
      2027,
      2028,
      2029,
      2030,
      2031,
      2030,
      2031,
      2032,
      2033,
      2034,
      2035,
      2036,
      2037,
      2038,
      2039,
      2040,
      2041,
      2042,
      2043,
      2044,
      2045,
      2046,
      2047,
      2048,
      2049,
      2050
    ];
  }

  getJPNDayDropDownList() {
    return ["日", "月", "火", "水", "木", "金", "土"];
  }

  getUSADayDropDownList() {
    return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}  



// WEBPACK FOOTER //
// ./src/app/services/common-service.ts